import {ApplicationEnum} from '@/services/api-clients';

export function  applicationTypeColorFilter(type: ApplicationEnum): string {
  switch(type) {
    case ApplicationEnum.Bolt: return '#34BB78';
    case ApplicationEnum.Lime: return '#bfff00';
    case ApplicationEnum.Dpd: return '#DC0032';
    case ApplicationEnum.BoltFood: return '#2fa96e';
    case ApplicationEnum.Glovo: return '#00a082';
    case ApplicationEnum.FreeNow: return '#FF1036';
    case ApplicationEnum.Stuart: return '#018DF7';
    case ApplicationEnum.Uber: return '#000000';
    case ApplicationEnum.UberEats: return '#00380b';
    case ApplicationEnum.Wolt: return '#00BBE3';
    case ApplicationEnum.XpressDelivery: return '#F2B80D';
    case ApplicationEnum.Novapost: return '#DA291C';
    case ApplicationEnum.Jush: return '#8ECA01';
    default: return '';
  }
}
